import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./ContactPopover.scss";

export interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

// TODO: This is a temporary contact modal. We need to replace it with a more permanent solution.
// Ideally this should use @ucl/library components. At the very least, syncfusion components.
export const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose }) => {
  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const modalContent = (
    <div className="contact-modal__backdrop" onClick={onClose}>
      <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
        <div className="contact-modal__header">
          <div className="contact-modal__icon">
            <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
              <path
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M22 16.92v3a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3.08 6.18 2 2 0 0 1 5 4h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.7 2.34a2 2 0 0 1-.45 2.11l-.7.7a16 16 0 0 0 6.29 6.29l.7-.7a2 2 0 0 1 2.11-.45c.74.34 1.53.57 2.34.7A2 2 0 0 1 22 16.92z"
              />
            </svg>
          </div>
          <h2 className="contact-modal__title">Contact Us</h2>
          <p className="contact-modal__subtitle">We're here to help with any questions</p>
        </div>

        <div className="contact-modal__content">
          <a href="tel:844-484-2889" className="contact-modal__item contact-modal__item--phone">
            <div className="contact-modal__item-icon">
              <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M22 16.92v3a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3.08 6.18 2 2 0 0 1 5 4h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.7 2.34a2 2 0 0 1-.45 2.11l-.7.7a16 16 0 0 0 6.29 6.29l.7-.7a2 2 0 0 1 2.11-.45c.74.34 1.53.57 2.34.7A2 2 0 0 1 22 16.92z"
                />
              </svg>
            </div>
            <div className="contact-modal__item-content">
              <div className="contact-modal__item-label">Phone</div>
              <div className="contact-modal__item-value">727-717-1735</div>
            </div>
            <div className="contact-modal__item-arrow">
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 17L17 7M17 7H7M17 7V17"
                />
              </svg>
            </div>
          </a>

          <a
            href="mailto:support@best.bank"
            className="contact-modal__item contact-modal__item--email"
          >
            <div className="contact-modal__item-icon">
              <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                />
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M22 6l-10 7L2 6"
                />
              </svg>
            </div>
            <div className="contact-modal__item-content">
              <div className="contact-modal__item-label">Email</div>
              <div className="contact-modal__item-value">support@best.bank</div>
            </div>
            <div className="contact-modal__item-arrow">
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 17L17 7M17 7H7M17 7V17"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );

  // Render modal at document.body level to avoid viewport constraints
  return createPortal(modalContent, document.body);
};

export default ContactModal;
